import React, { Component } from 'react';

import equals from 'fast-deep-equal';

import styles from 'editor/workspace/window/viewer/sheet/sheet.module.scss';

export default class Cell extends Component {
    render () {
        const cellIdx = this.props.j;
        const rowIdx = this.props.i;
        let cell = this.props.cell;
        const step = this.props.step;
        const range = this.props.range;
        const l = this.props.l;

        // Determine whether cell is different from uploaded
        const uploaded = this.props.uploaded.matrix.formatData();
        const isChanged = cell !== uploaded[rowIdx][cellIdx];

        // Determine cell shade for heatMap
        let heatMap = Math.round((range + (l - cell)) / step);
        heatMap = `heatMap-${heatMap}`;
        if(range === 0) heatMap = "heatMap-4";

        // Detect if this is a selected cell and if it's a corner
        let selected = false;
        let edgePoint = null;
        let cornerPoint = null;
        let offsetY = null;
        let offsetX = null;
        if(this.props.selection.topLeft && this.props.selection.bottomRight){
            const topLeft = this.props.selection.topLeft;
            const bottomRight = this.props.selection.bottomRight;
            selected = rowIdx >= topLeft.i && rowIdx <= bottomRight.i && cellIdx >= topLeft.j && cellIdx <= bottomRight.j;

            if((topLeft.i - bottomRight.i) && (topLeft.j - bottomRight.j)){
                //(>2)x(>2) selections
                if(rowIdx === topLeft.i && cellIdx === Math.floor( (bottomRight.j - topLeft.j) / 2) + topLeft.j ) edgePoint = "top";
                if(rowIdx === Math.floor( (bottomRight.i - topLeft.i) / 2) + topLeft.i && cellIdx === bottomRight.j ) edgePoint = "right";
                if(rowIdx === Math.round( (bottomRight.i - topLeft.i) / 2) + topLeft.i && cellIdx === topLeft.j ) edgePoint = "left";
                if(rowIdx === bottomRight.i && cellIdx === Math.round( (bottomRight.j - topLeft.j) / 2) + topLeft.j ) edgePoint = "bottom";

                if(rowIdx === topLeft.i && cellIdx === topLeft.j) cornerPoint = "tl";
                if(rowIdx === topLeft.i && cellIdx === bottomRight.j) cornerPoint = "tr";
                if(rowIdx === bottomRight.i && cellIdx === topLeft.j) cornerPoint = "bl";
                if(rowIdx === bottomRight.i && cellIdx === bottomRight.j) cornerPoint = "br";

                if(Math.round( (bottomRight.j - topLeft.j) / 2) !==  (bottomRight.j - topLeft.j) / 2) offsetY = "offsetX";
                if(Math.round( (bottomRight.i - topLeft.i) / 2) !==  (bottomRight.i - topLeft.i) / 2) offsetX = "offsetY";
            } else {
                //1x(>1) selections
                if((bottomRight.j - topLeft.j) >= 1 && rowIdx === bottomRight.i && cellIdx === bottomRight.j) edgePoint = "right";
                if((bottomRight.j - topLeft.j) >= 1 && rowIdx === topLeft.i && cellIdx === topLeft.j) edgePoint = "left";

                if((bottomRight.i - topLeft.i) >= 1 && rowIdx === bottomRight.i && cellIdx === bottomRight.j) edgePoint = "bottom";
                if((bottomRight.i - topLeft.i) >= 1 && rowIdx === topLeft.i && cellIdx === topLeft.j) edgePoint = "top";

                //1x1 selections
                if (bottomRight.i - topLeft.i === 0 && rowIdx === bottomRight.i && cellIdx === bottomRight.j) edgePoint = "right";
            }
        }

        // Build classes
        let classes = `cell ${heatMap} highlightSecondary`;
        if(isChanged) classes = `${classes} ${styles.changed}`;
        if(selected) classes = `${classes} ${styles.selected}`;

        // Calculate cell changes
        const relativeChange = cell - uploaded[rowIdx][cellIdx];
        let percentageChange = relativeChange / uploaded[rowIdx][cellIdx] * 100;
        if(!isFinite(percentageChange)) percentageChange = 0;

        // Set cell value if diffType is not "Actual"
        switch(this.props.diffType){
            case "relative":
                cell = (relativeChange).toFixed(2);
                break;
            case "percentage":
                cell = `${(percentageChange).toFixed(2)}%`;
                break;
            default:
        }

        return (
            <>
                <td key={cellIdx} data-i={rowIdx} data-j={cellIdx} className={classes}>
                    {cell}
                    {edgePoint &&
                    <span
                        className={`${styles.dot} point-${edgePoint} ${offsetY ? "offsetY" : null} ${offsetX ? "offsetX" : null} ${equals(this.props.point, edgePoint) ? "active" : null }`}
                        onMouseDown={this.props.setPoint.bind(this, edgePoint)}
                        onTouchStart={this.props.setPoint.bind(this, edgePoint)}
                    />}
                    {cornerPoint &&
                    <span
                        className={`${styles.dot} point-${cornerPoint} ${offsetY ? "offsetY" : null} ${offsetX ? "offsetX" : null} ${equals(this.props.point, cornerPoint) ? "active" : null }`}
                        onMouseDown={this.props.setPoint.bind(this, cornerPoint)}
                        onTouchStart={this.props.setPoint.bind(this, cornerPoint)}
                    />}
                </td>
            </>
        )
    }
}